import { FC } from "react";
import styled from "styled-components";
import { EVIAN_COLORS } from "../../utils/Colors";

const radii = {
  md: "10px",
  lg: "14px",
  xl: "18px",
};

const shadow = {
  card: "0 1px 2px rgba(16,24,40,0.06), 0 1px 3px rgba(16,24,40,0.1)",
  inset: "inset 0 1px 0 rgba(255,255,255,0.4)",
};

const Page = styled.div`
  min-height: 100dvh;
  background: ${EVIAN_COLORS.bg};
  display: flex;
  justify-content: center;
  padding: 40px 16px;
`;
const ErrorCard = styled.div`
  width: 100%;
  max-width: 500px;
  background: ${EVIAN_COLORS.panel};
  border: 1px solid ${EVIAN_COLORS.border};
  border-radius: ${radii.xl};
  box-shadow: ${shadow.card};
  padding: 40px 28px;
  text-align: center;
`;

const ErrorIcon = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: ${EVIAN_COLORS.errorBg};
  border: 1px solid ${EVIAN_COLORS.errorBorder};
  border-radius: 50%;
  margin-bottom: 20px;
  font-size: 28px;
`;

const ErrorTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: ${EVIAN_COLORS.errorText};
  margin: 0 0 12px 0;
`;

const ErrorMessage = styled.p`
  font-size: 16px;
  color: ${EVIAN_COLORS.text};
  line-height: 1.5;
  margin: 0 0 24px 0;
`;

const ErrorDetails = styled.div`
  background: ${EVIAN_COLORS.errorBg};
  border: 1px solid ${EVIAN_COLORS.errorBorder};
  border-radius: ${radii.md};
  padding: 16px;
  margin-bottom: 24px;
  text-align: left;
`;

const ErrorDetailsTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: ${EVIAN_COLORS.errorText};
  margin: 0 0 8px 0;
`;

const ErrorDetailsList = styled.ul`
  margin: 0;
  padding-left: 20px;
  color: ${EVIAN_COLORS.text};
  font-size: 14px;
  line-height: 1.5;
`;

const RetryButton = styled.button`
  height: 48px;
  border: 1px solid ${EVIAN_COLORS.primary};
  background: ${EVIAN_COLORS.primary};
  color: white;
  font-weight: 700;
  border-radius: ${radii.md};
  cursor: pointer;
  transition: all 0.15s ease;
  padding: 0 24px;

  &:hover {
    background: ${EVIAN_COLORS.primaryHover};
    border-color: ${EVIAN_COLORS.primaryHover};
  }

  &:active {
    transform: translateY(1px);
  }
`;

interface Props {
  handleRetry: VoidFunction;
  errorMessage: string;
}

export const EvianErrorCheckPwd: FC<Props> = ({ handleRetry, errorMessage }) => {
  return (
    <Page>
      <ErrorCard>
        <ErrorIcon>⚠️</ErrorIcon>
        <ErrorTitle>Unauthorized Access</ErrorTitle>
        <ErrorMessage>
          Sorry, you don't have access to this registration form.
          This exclusive sweepstakes is available only to participants
          who recycled at the Olyns Cube during the evian F1 activation in Las Vegas.
        </ErrorMessage>

        <ErrorDetails>
          <ErrorDetailsTitle>Reasons:</ErrorDetailsTitle>
          <ErrorDetailsList>
            <li>{errorMessage}</li>
          </ErrorDetailsList>
        </ErrorDetails>

        <RetryButton onClick={handleRetry}>
          Try Again
        </RetryButton>
      </ErrorCard>
    </Page>
  );
};